"use client"
import React from 'react';
import { Badge, Button, ButtonStyle, Card, CardTitle, ComponentDataTable, Grid, GridItem, Loader, Table, TableSlotType } from '@develos/next-components';
import { useFetch, usePageLocation, useTranslations } from '@develos/next-library';
import { storeSelectors, usePropertyUpdate } from '@/store';
import { setActiveRecord } from '@/store/liveView';
import { VehicleRecordDetailsType } from '@/types';
import { badgeVariant, isOwerweightText, mapToPlatform } from '@/helpers';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/navigation';

const ListOfVehicles = () => {
  const { translate } = useTranslations();
  const { get } = useFetch();
  const { getPageLocation } = usePageLocation();
  const { push } = useRouter();
  const currentMetricLocalization = useSelector(storeSelectors.selectCurrentMetricLocalization);
  const vehiclesList = useSelector(storeSelectors.selectVehiclesList);
  const { data: tableConfig, isLoading } = get<ComponentDataTable<VehicleRecordDetailsType>>('LiveVehiclesRecords/GetLiveDataTableConfiguration')

  const { propertyValue: activeRecord, updateStoreProp: updateActiveRecord } = usePropertyUpdate(
    setActiveRecord, 
    storeSelectors.selectActiveRecord
  );
  
  const slotedScopes: TableSlotType<VehicleRecordDetailsType & { actions: string }> = {
    platformId: (row: VehicleRecordDetailsType, index: number) => {
      return mapToPlatform(row.platformId, currentMetricLocalization);
    },
    isOverweight: (row: VehicleRecordDetailsType, index: number) => {
      return (
        <Badge variant={badgeVariant(row.isOverweight)} >
          {isOwerweightText(row.isOverweight)}
        </Badge>
      );
    },
    weight: (row: VehicleRecordDetailsType, index: number) => `${row.weight} kg`,
    actions: (row: VehicleRecordDetailsType, index: number) => {
      const buttons = [];
      if (activeRecord != null && row.id === activeRecord.id) {
        buttons.push(
          <Button key="active" variant='light' size="sm" leftIcon='CheckCheck'>
            Aktywny
          </Button>
        );
      } else {
        buttons.push(
          <Button key="details" size="sm" handleClick={() => updateActiveRecord(row)} leftIcon='Info'>
            Szczegóły
          </Button>
        );
      }
      if (row.weight >= 3500) {
        buttons.push(
          <Button key="limit" style={ButtonStyle.Outlined} size="sm" leftIcon="CalendarDays" handleClick={() => push(getPageLocation('TrafficHistory', { above35LastDayPlateNumber: row.lpnumber }))}>
            Dobowa
          </Button>
        );
      }
      return (
        <Grid gap={2}>
          {buttons.map((button, index) => (
            <GridItem key={index}>
              {button}
            </GridItem>
          ))}
        </Grid>
      )
    }
  };

  return (
    <Card>
      <Card.Body>
        {isLoading && <Loader isAbsolute/>}
        <CardTitle title={translate('Podgląd przejazdów')}/>
        <Table
          data={vehiclesList}
          headers={tableConfig?.headers ?? []}
          options={tableConfig?.options ?? { headings: {} }}
          slots={slotedScopes} 
          showTextFilter={true}
        />
      </Card.Body>
    </Card>
  );
};

export default ListOfVehicles;
